import { render } from "./CaseMenuNavigationItem.vue?vue&type=template&id=668d2af8&scoped=true"
import script from "./CaseMenuNavigationItem.vue?vue&type=script&lang=js"
export * from "./CaseMenuNavigationItem.vue?vue&type=script&lang=js"

import "./CaseMenuNavigationItem.vue?vue&type=style&index=0&id=668d2af8&scoped=true&lang=scss"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668d2af8"]])

export default __exports__